import { authenticationService } from '../services/AuthService'
import { localStorageService } from '../services/localstorage-service';

const DEFAULT_LOGIN_ERROR = 'Feil brukernavn eller passord';

function resolveLoginErrorMessage(response) {
  if (response && typeof response === 'object' && response.message) {
    return response.message;
  }
  if (typeof response === 'string' && response.length > 0) {
    return response;
  }
  return DEFAULT_LOGIN_ERROR;
}

export async function signIn(email, password, isChecked) {
  try {
    const response = await AuthUser(email, password, isChecked);
    if (response && response.employee != null) {
      return {
        isOk: true,
        data: response
      };
    }
    return {
      isOk: false,
      message: resolveLoginErrorMessage(response)
    };
  }
  catch (err) {
    return {
      isOk: false,
      message: err?.message || DEFAULT_LOGIN_ERROR
    };
  }
}

export async function getUserName() {
  try {
    // Send request
    return {
      isOk: true,
      data: localStorageService.getUserName()
    };
  }
  catch {
    return {
      isOk: false
    };
  }
}

const AuthUser = async (email, password, isChecked) => {
  try {
    if (!localStorageService.hasCompleteAuthSession()) {
      if (localStorageService.hasPartialAuthSession()) {
        localStorageService.clearStorage();
      }
      if (isChecked === null || isChecked === undefined) {
        isChecked = false;
      }
      const response = await authenticationService.login(email, password, isChecked);
      if (response && response.employee) {
        localStorageService.setAuthToken(response.token);
        localStorageService.setUserName(response.employee.name);
        localStorageService.setStoresEmployee(JSON.stringify(response.storeEmployee));
        const supplierAccess = response.supplierAccess ?? response.SupplierAccess;
        if (supplierAccess) {
          localStorageService.setSupplierAccess(supplierAccess);
        } else {
          localStorageService.setSupplierAccess(null);
        }
        return response;
      }
      return response;
    }
    return {
      token: localStorageService.getAuthToken(),
      employee: { name: localStorageService.getUserName() }
    };
  }
  catch (err) {
    throw err;
  }
}

export async function createAccount(email, password) {
  try {
    // Send request
    console.log(email, password);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to create account"
    };
  }
}

export async function changePassword(email, recoveryCode) {
  try {
    // Send request
    console.log(email, recoveryCode);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to change password"
    }
  }
}

export async function resetPassword(email) {
  try {
    // Send request
    console.log(email);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to reset password"
    };
  }
}
